import React, { useEffect, useState } from "react"
import { useParams, Link } from "react-router-dom"
import { getAdminOrderById } from "../../services/orders"
import {
    ArrowLeftIcon,
    PrinterIcon
} from "@heroicons/react/24/outline"

const AdminOrderDetails = () => {
    const { orderId } = useParams()
    const [order, setOrder] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState("")

    const fetchOrder = async () => {
        setLoading(true)
        setError("")
        try {
            const res = await getAdminOrderById(orderId)
            if (res.status === 200) {
                setOrder(res.data)
            } else {
                setError(res.error || "Order not found")
            }
        } catch (err) {
            setError("Failed to fetch order")
        }
        setLoading(false)
    }

    useEffect(() => { fetchOrder() }, [orderId])

    if (loading) return <div className="text-center py-20">Loading...</div>
    if (!order) return <div className="text-center py-20">Order not found</div>

    return (
        <div className="max-w-3xl mx-auto">
            <Link to="/admin/orders" className="inline-flex items-center gap-2 text-slate-500 hover:text-slate-900 mb-6">
                <ArrowLeftIcon className="w-4 h-4" /> Back to Orders
            </Link>

            <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden p-8 md:p-12">
                <div className="flex justify-between items-start mb-12">
                    <div>
                        <h1 className="text-3xl font-bold text-slate-900 mb-1">Invoice</h1>
                        <p className="text-slate-500">Order ID: {order._id}</p>
                    </div>
                    <div className="text-right">
                        <span className={`inline-block px-4 py-2 rounded-lg text-sm font-bold uppercase ${order.status === 'PAID' ? 'bg-green-100 text-green-700' : 'bg-slate-100 text-slate-700'
                            }`}>
                            {order.status}
                        </span>
                    </div>
                </div>

                <div className="grid grid-cols-2 gap-8 mb-12 border-b border-slate-100 pb-12">
                    <div>
                        <h3 className="text-sm font-bold text-slate-400 uppercase mb-2">Billed To</h3>
                        <p className="font-medium text-slate-900">{order.attendeeId?.name || 'User'}</p>
                        <p className="text-slate-600">{order.attendeeId?.email}</p>
                    </div>
                    <div className="text-right">
                        <h3 className="text-sm font-bold text-slate-400 uppercase mb-2">Details</h3>
                        <p className="text-slate-600">Date: {new Date(order.createdAt).toLocaleDateString()}</p>
                        <p className="text-slate-600">Type: {order.orderType || 'EVENT'}</p>
                    </div>
                </div>

                <div className="mb-12">
                    <h3 className="text-sm font-bold text-slate-400 uppercase mb-4">Items</h3>
                    <div className="bg-slate-50 rounded-lg p-6">
                        {order.items && order.items.map((item, i) => (
                            <div key={i} className="flex justify-between items-center py-2 border-b last:border-0 border-slate-200">
                                <div>
                                    <p className="font-bold text-slate-900">{item.eventTitle || 'Event Ticket'}</p>
                                    <p className="text-sm text-slate-500">{item.ticketTypeName}</p>
                                </div>
                                <p className="font-bold text-slate-900">₦{item.price?.toLocaleString()}</p>
                            </div>
                        ))}
                        <div className="flex justify-between items-center pt-4 mt-2 border-t border-slate-200">
                            <p className="font-bold text-lg text-slate-900">Total</p>
                            <p className="font-bold text-2xl text-cyan-600">₦{order.total?.toLocaleString()}</p>
                        </div>
                    </div>
                </div>

                <div className="text-center">
                    <p className="text-slate-400 text-sm mb-6">Assuming this invoice was paid via configured payment gateway.</p>
                    <button onClick={() => window.print()} className="inline-flex items-center gap-2 px-6 py-2 border border-slate-300 rounded-lg text-slate-700 hover:bg-slate-50 font-medium">
                        <PrinterIcon className="w-5 h-5" /> Print Invoice
                    </button>
                </div>
            </div>
        </div>
    )
}

export default AdminOrderDetails
